import { OrderSummaryCard } from "@hatch-digital-nl/bravilor-storybook";
import { JSX } from "react";
import { useGetUserInfoQuery } from "../../../app/rootReducer";
import { useStringTranslation } from "../../../common/hooks/useStringTranslation";
import { useCart } from "../hooks/useCart";
import { useCartPageLoading } from "../hooks/useCartPageLoading";
import { CartOrderSummarySkeleton } from "./CartPageSkeletons";

export const CartOrderSummary = (): JSX.Element | null => {
    const { pendingOrder, cartLabels, handleCheckoutFromPage } = useCart();
    const { t } = useStringTranslation();
    const { data: userData } = useGetUserInfoQuery();
    const activeLanguage = userData?.activeLanguage ?? null;
    const isPageLoading = useCartPageLoading();

    if (isPageLoading) {
        return <CartOrderSummarySkeleton />;
    }

    if (!pendingOrder?.order_lines.length || !activeLanguage?.localeCode) {
        return null;
    }

    const itemsLabel = t("cart-order-summary-items").replace(
        "{count}",
        String(pendingOrder.order_lines.length),
    );

    return (
        <OrderSummaryCard
            itemsCount={pendingOrder.order_lines.length}
            itemsTotal={pendingOrder.items_total}
            discount={pendingOrder.discount_total ?? undefined}
            total={pendingOrder.total}
            title={t("cart-order-summary-title")}
            itemsLabel={itemsLabel}
            discountLabel={t("cart-order-summary-discount")}
            totalLabel={t("cart-order-summary-total")}
            checkoutLabel={cartLabels.checkoutLabel}
            disclaimer={t("cart-order-disclaimer")}
            onCheckout={handleCheckoutFromPage}
        />
    );
};
